import { render, staticRenderFns } from "./EditBulkSpj.vue?vue&type=template&id=1b4e7cc3&"
import script from "./EditBulkSpj.vue?vue&type=script&lang=js&"
export * from "./EditBulkSpj.vue?vue&type=script&lang=js&"
import style0 from "./EditBulkSpj.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports